var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-rank-setter_style" },
    [
      _c(
        "yxt-form",
        {
          ref: "rankForm",
          attrs: {
            model: _vm.rankForm,
            rules: _vm.rules,
            enableDetectFieldsChange: _vm.isInitialFinished,
            "label-position": "top",
          },
        },
        [
          _c(
            "yxt-form-item",
            {
              staticClass: "yxtbiz-rank-setter_style_select_item",
              attrs: {
                label: _vm
                  .$t("pc_biz_rank_default_rank_period")
                  .d("默认排行周期"),
                prop: "defaultDateType",
              },
            },
            [
              _c(
                "yxt-select",
                {
                  staticClass: "mt8 yxtbiz-rank-setter_style_select",
                  attrs: {
                    size: "small",
                    placeholder: _vm.$t("pc_biz_lbl_selecttip").d("请选择"),
                  },
                  model: {
                    value: _vm.rankForm.defaultDateType,
                    callback: function ($$v) {
                      _vm.$set(_vm.rankForm, "defaultDateType", $$v)
                    },
                    expression: "rankForm.defaultDateType",
                  },
                },
                _vm._l(_vm.dateList, function (item) {
                  return _c("yxt-option", {
                    key: item.type,
                    attrs: {
                      label: _vm.$t(item.label).d(item.text),
                      value: item.type,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "yxt-form-item",
            {
              staticClass: "yxtbiz-rank-setter_style_select_item",
              attrs: {
                label: _vm
                  .$t("pc_biz_rank_show_how_many_top")
                  .d("展示前多少名"),
                prop: "rankTop",
              },
            },
            [
              _c("yxt-input-number", {
                staticClass: "mt8 yxtbiz-rank-setter_style_input_number",
                attrs: { size: "small", precision: 0, min: 3, max: 200 },
                on: { blur: _vm.onRankTopBlur },
                model: {
                  value: _vm.rankForm.rankTop,
                  callback: function ($$v) {
                    _vm.$set(_vm.rankForm, "rankTop", $$v)
                  },
                  expression: "rankForm.rankTop",
                },
              }),
              _c("span", { staticClass: "ml12 text-8c standard-size-12" }, [
                _vm._v(
                  _vm._s(_vm.$t("pc_biz_rank_show_tip").d("支持展示3-200名"))
                ),
              ]),
            ],
            1
          ),
          _c(
            "yxt-form-item",
            {
              staticClass: "mb15",
              attrs: {
                label: _vm.$t("pc_biz_rank_show_rule").d("相同数值排名"),
                prop: "rankType",
              },
            },
            [
              _c(
                "yxt-radio-group",
                {
                  model: {
                    value: _vm.rankForm.rankType,
                    callback: function ($$v) {
                      _vm.$set(_vm.rankForm, "rankType", $$v)
                    },
                    expression: "rankForm.rankType",
                  },
                },
                _vm._l(_vm.typeList, function (item) {
                  return _c(
                    "yxt-radio",
                    { key: item.type, attrs: { label: item.type } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t(item.label)) +
                          "\n          "
                      ),
                      _c(
                        "yxt-tooltip",
                        {
                          attrs: {
                            effect: "light",
                            placement: "top",
                            "max-height": "130",
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "yxtbiz-rank-setter_style_rankType_img",
                              attrs: { slot: "content" },
                              slot: "content",
                            },
                            [
                              _c("yxt-image", {
                                attrs: {
                                  width: "92px",
                                  height: "112px",
                                  src:
                                    _vm.$staticBaseUrl +
                                    "ufd/55a3e0/ssp/pc/img/" +
                                    item.icon +
                                    ".png",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "span",
                            {
                              staticClass:
                                "yxtbiz-rank-setter_style_question-icon",
                              staticStyle: { cursor: "auto" },
                            },
                            [
                              _c("yxt-svg", {
                                staticClass: "color-gray-6 hover-primary-6",
                                attrs: {
                                  width: "16px",
                                  height: "16px",
                                  "icon-class": "icons/question-cirlce-o",
                                },
                              }),
                            ],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "yxt-form-item",
            {
              staticClass: "yxtbiz-rank-setter_style_showContent mb15",
              attrs: {
                label: _vm.$t("pc_biz_rank_show_content").d("展示内容"),
                prop: "rankContent",
              },
            },
            [
              _c(
                "yxt-checkbox-group",
                {
                  on: { change: _vm.onContentChange },
                  model: {
                    value: _vm.rankForm.rankContent,
                    callback: function ($$v) {
                      _vm.$set(_vm.rankForm, "rankContent", $$v)
                    },
                    expression: "rankForm.rankContent",
                  },
                },
                _vm._l(_vm.contentList, function (item) {
                  return _c(
                    "yxt-checkbox",
                    {
                      key: item.type,
                      attrs: { label: item.type, disabled: !item.select },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t(item.label).d(item.text))),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "yxt-form-item",
            {
              attrs: {
                label: _vm.$t("pc_biz_rank_show_style").d("展示样式"),
                prop: "rankStyle",
              },
            },
            [
              _c(
                "yxt-radio-group",
                {
                  staticClass: "mt8 yxtbiz-rank-setter_style_rankStyle flex",
                  model: {
                    value: _vm.rankForm.rankStyle,
                    callback: function ($$v) {
                      _vm.$set(_vm.rankForm, "rankStyle", $$v)
                    },
                    expression: "rankForm.rankStyle",
                  },
                },
                _vm._l(_vm.styleList, function (item) {
                  return _c(
                    "div",
                    {
                      key: item.type,
                      staticClass: "mr24 yxtbiz-rank-setter_style_img_box",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "yxtbiz-rank-setter_style_img" },
                        [
                          _c("yxt-image", {
                            attrs: {
                              width: "56px",
                              height: "83px",
                              src:
                                _vm.$staticBaseUrl +
                                "ufd/55a3e0/ssp/pc/img/" +
                                item.icon +
                                ".png",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "yxt-tooltip",
                        {
                          attrs: {
                            disabled: !(item.type === 2 && _vm.styleDisabled),
                            content: _vm
                              .$t("pc_biz_rank_style_tip")
                              .d("必须选择部门图标来适配样式"),
                          },
                        },
                        [
                          _c(
                            "yxt-radio",
                            {
                              attrs: {
                                label: item.type,
                                disabled: item.type === 2 && _vm.styleDisabled,
                              },
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t(item.label).d(item.text)) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }